/* eslint-disable max-len */
import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const DisconnectIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <BaseIcon {...props}>
      <g transform="translate(3.64, 2.96) scale(2)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6522 0L0 11.6522L0.707107 12.3593L1.88541 11.181C1.97724 11.2088 2.07464 11.2238 2.17554 11.2238H9.56489L8.65041 12.1382C8.45515 12.3335 8.45515 12.6501 8.65041 12.8453C8.84568 13.0406 9.16226 13.0406 9.35752 12.8453L10.9485 11.2544C11.2414 10.9615 11.2414 10.4866 10.9485 10.1937L9.35752 8.6027C9.16226 8.40744 8.84568 8.40744 8.65041 8.6027C8.45515 8.79796 8.45515 9.11454 8.65041 9.30981L9.56436 10.2238H2.84268L6.84268 6.22376H10.1755C10.7278 6.22376 11.1755 5.77604 11.1755 5.22376V1.8909L12.3593 0.707107L11.6522 0ZM10.1755 2.8909L7.84268 5.22376H10.1755V2.8909Z"
        />
        <path d="M2.17554 6.22376H4.07544L5.07544 5.22376H2.17554C1.62325 5.22376 1.17554 5.67147 1.17554 6.22376V9.12366L2.17554 8.12366V6.22376Z" />
        <path d="M10.0754 0.223756L9.07544 1.22376H1.42554C1.14939 1.22376 0.925537 0.999898 0.925537 0.723756C0.925537 0.447613 1.14939 0.223756 1.42554 0.223756H10.0754Z" />
      </g>
    </BaseIcon>
  );
};
